export default __webpack_public_path__ + "static/media/Grid3.10.28d384b2.jpg";